import { motion } from 'framer-motion';
import React from 'react';

type AnimatedListProps = {
  children: React.ReactNode;
  isEnabled: boolean;
};

export const AnimatedList = ({ children, isEnabled }: AnimatedListProps) => {
  return (
    <motion.div
      className="max-h-[30rem] w-full flex-col gap-4 overflow-y-scroll"
      animate={{
        display: isEnabled ? 'flex' : 'none',
        opacity: isEnabled ? 1 : 0,
        height: isEnabled ? '100%' : '0rem',
        transition: {
          ease: 'easeOut',
          duration: 0.3,
        },
      }}
      exit={{
        display: 'none',
        opacity: 0,
        height: '0rem',
      }}
    >
      {children}
    </motion.div>
  );
};

type EmptyAnimatedListProps = {
  isEnabled: boolean;
  type: 'garage' | 'sizes';
};

export const EmptyAnimatedList = ({ isEnabled, type }: EmptyAnimatedListProps) => {
  return (
    <motion.div
      className="w-full flex-col gap-4"
      animate={{
        display: isEnabled ? 'flex' : 'none',
        opacity: isEnabled ? 1 : 0,
        height: isEnabled ? '100%' : '0rem',
        transition: {
          ease: 'easeOut',
          duration: 0.3,
        },
      }}
    >
      <div className="flex h-[10rem] w-full items-center justify-center rounded-[1rem] bg-[#D9D9D9]">
        <p className="text-center text-[1.8rem] font-medium text-zinc-600">
          {type === 'garage'
            ? 'Your garage is empty. Add your first bike!'
            : 'No saved sizes yet. Add your measurements to get started.'}
        </p>
      </div>
    </motion.div>
  );
}; 
